import ProcessRoutes from "./process";

export default [...ProcessRoutes];
